export const inProcess = ['ordered', 'failed', 'stopped', 'canceled', 'refunded'];

export const ordered = ['shipped', 'canceled', 'returned', 'refunded'];

export const shipped = ['completed', 'returned', 'refunded', 'canceled'];

export const completed = ['returned', 'refunded', 'canceled'];

export const canceled = ['refunded'];

export const returned = ['inProcess', 'completed', 'refunded', 'canceled'];

export const refunded = ['canceled'];

export const failed = [
  'inProcess',
  'ordered',
  'shipped',
  'completed',
  'returned',
  'refunded',
  'canceled',
];

export const stopped = [
  'inProcess',
  'ordered',
  'shipped',
  'completed',
  'failed',
  'returned',
  'refunded',
  'canceled',
];

export const exported = ['failed', 'ordered'];

export const notPaid = ['canceled'];

export const allowedStatuses = {
  inProcess,
  ordered,
  shipped,
  completed,
  canceled,
  returned,
  refunded,
  failed,
  stopped,
  exported,
  notPaid,
};
